/**
 * Created by fers on 05.02.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import urlMapping from '../app/URLMapping';
import ActivateFlowMutation from './ActivateFlowMutation.react';
import {LoadingLine} from '../loadingLine/renderLoadingPanel.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import AppPanel from '../fw/AppPanel.react';
import ScenarioBoxAsWizard from '../scenarios/ScenarioBoxAsWizard.react';
import ScenarioIcon from '../scenarios/ScenarioIcon.react';
import "../scenarios/Scenario.scss";
import ScenarioWizard from '../scenarios/ScenarioWizard.react';
import EventTracker from '../app/EventTracker';
import mutationError from '../channel-defs/mutationError';
import {getLastOrganisationId} from '../app/LastOrganisationId';

const messages = defineMessages({
	title: {id: 'flowAddStep4.title', 'defaultMessage': 'Editing flow'}
});

class FlowAddStep4 extends React.Component {

	static propTypes = {
		intl: PropTypes.object.isRequired,
		relay: PropTypes.object.isRequired,
		user: PropTypes.object.isRequired,
	};
	typeName = 'flows';

	static contextTypes = {
		router: PropTypes.object
	};

	constructor() {
		super();
	}

	_create = () => {
		return new Promise((resolve, reject) => {
			const flow = this.props.user.organisation.flow;

			let onSuccess = (response) => {
				EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
					event: 'flow-add-success',
					type: 'application'
				});

				/* are we creating this channel as part of scenario? */
				if (this.props.user.scenario) {
					let args = {
						'organisation_id': this.props.user.organisation['realId'],
						'scenario_id': this.props.user.scenario['realId'],
						'urlFragment': this.props.user.scenario['urlFragment'],
					};

					let path = urlMapping.getUrl(types['flows'], "scenario-apply-flow", args);
					this.context.router.push(path);
				} else {
					let path = urlMapping.getUrl(types['flows'], "view",  this.props.user.organisation.flow);
					this.context.router.push(path);
				}

				resolve();
			};
			let onFailure = (transaction) => {
				let error = mutationError(transaction);
				reject(error);
			};

			this.props.relay.commitUpdate(
				new ActivateFlowMutation({
					flow_id: flow['realId'],
					organisation_id: this.props.user.organisation['realId']
				}), {onSuccess: onSuccess, onFailure: onFailure}
			);

		});
	};

	componentWillMount() {
		this._create();
	}

	render() {
		const {flow} = this.props.user.organisation;
		let flowDef = flow.flowDef;
		let type = types['flowDefs'];

		return (
			<AppPanel  breadcrumbParams={[
				{type: types['flows'], data: flow},
				{type: types['scenarios'], data: this.props.user.scenario},
				{type: types['organisations'], data: this.props.user.organisation}]
			} title={this.props.intl.formatMessage(messages.title)}>
				<ScenarioWizard data={this.props.user} step={3} type={type}>
					<h2><div className="channelAdd-logo">{flowDef.name}</div></h2>

					<p><FormattedMessage defaultMessage="Your Flow is ready to be used." id="flow.finish.description" /></p>

					<LoadingLine withMessage>
						<FormattedMessage defaultMessage="Activating flow…" id="flow.finish.working" />
					</LoadingLine>
				</ScenarioWizard>
			</AppPanel>
		);
	}
}


export default Relay.createContainer(wrapNotFound(injectIntl(FlowAddStep4), (props) => {
	return props.user.organisation && props.user.organisation.flow;
}), {
	initialVariables: {
		flowId: '',
		organisationId: '',
		scenarioId: '',
		scenarioSelected: false,
	},
	prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

		variables['scenarioSelected'] = variables['scenarioId'] ? true : false;

		return variables;
	},
	fragments: {
		user: () => Relay.QL`
			fragment on User {
				scenario(id: $scenarioId) @include(if: $scenarioSelected) {
					id,
					realId,
					urlFragment,
					${ScenarioBoxAsWizard.getFragment('scenario')},
					${ScenarioIcon.getFragment('scenario')}
				},
				organisation(id: $organisationId) {
					id,
					realId,
					${ScenarioBoxAsWizard.getFragment('organisation')},
					name,
					flow(id: $flowId) {
						id,
						realId,
						organisation_id,
						enabled,
						activated,
						name,
						flowDef {
							id,
							realId,
							name,
						}
					}
				},
			}
		`,
	},
});
